import { render, staticRenderFns } from "./tariffs.vue?vue&type=template&id=059d7272&scoped=true"
import script from "./tariffs.vue?vue&type=script&lang=js"
export * from "./tariffs.vue?vue&type=script&lang=js"
import style0 from "./tariffs.vue?vue&type=style&index=0&id=059d7272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d7272",
  null
  
)

export default component.exports